import { PaymentRankItem } from '../payment-rank-interface';

export class AddPaymentRank {
  static readonly type = '[PaymentRank] Add Payment Rank';
  constructor(public paymentRank: PaymentRankItem) {}
}

export class UpdatePaymentRank {
  static readonly type = '[PaymentRank] Update Payment Rank';
  constructor(public paymentRank: PaymentRankItem) {}
}

export class DeletePaymentRank {
  static readonly type = '[PaymentRank] Delete Payment Rank';
  constructor(public id: number) {}
}

export class FetchPaymentRanks {
  static readonly type = '[PaymentRank] Fetch Payment Ranks';
}
